import http from '@/http'

const BASE = '/admin/app'

/* ===== Ativação / modo de login (Onda 0) ===== */
export const getAppConfig = () => http.get(`${BASE}/config`)
export const saveAppConfig = (payload) => http.put(`${BASE}/config`, payload)

/* ===== Configurações / branding (Onda 1) ===== */
export const getAppSettings = () => http.get(`${BASE}/settings`)
export const updateAppInfo = (payload) => http.put(`${BASE}/settings`, payload)
export const updateColors = (payload) => http.put(`${BASE}/settings/colors`, payload)
export const updateAccount = (payload) => http.put(`${BASE}/settings/account`, payload)
export const updateInteractions = (payload) => http.put(`${BASE}/settings/interactions`, payload)
// Integrações (OneSignal/Pusher/Chat) agora são gerenciadas pelo Master Panel
export const getTerms = () => http.get(`${BASE}/settings/terms`)
export const updateTerms = (payload) => http.put(`${BASE}/settings/terms`, payload)

export const uploadImage = (field, file) => {
  const form = new FormData()
  form.append('field', field)
  form.append(field, file)
  return http.post(`${BASE}/settings/images`, form, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
export const deleteImage = (field) => http.delete(`${BASE}/settings/images`, { data: { field } })

/* ===== Menu ===== */
export const listMenu = () => http.get(`${BASE}/menu`)
export const showMenu = (id) => http.get(`${BASE}/menu/${id}`)
export const createMenu = (payload) => http.post(`${BASE}/menu`, payload)
export const updateMenu = (id, payload) => http.put(`${BASE}/menu/${id}`, payload)
export const changeMenuStatus = (id) => http.put(`${BASE}/menu/${id}/status`)
export const reorderMenu = (itens) => http.put(`${BASE}/menu/sequence`, { itens })
export const deleteMenu = (id) => http.delete(`${BASE}/menu/${id}`)

/* ===== Feed channels ===== */
export const listFeed = () => http.get(`${BASE}/feed`)
export const createFeed = (payload) => http.post(`${BASE}/feed`, payload)
export const updateFeed = (id, payload) => http.put(`${BASE}/feed/${id}`, payload)
export const changeFeedStatus = (id) => http.put(`${BASE}/feed/${id}/status`)
export const reorderFeed = (itens) => http.put(`${BASE}/feed/sequence`, { itens })
export const deleteFeed = (id) => http.delete(`${BASE}/feed/${id}`)

/* ===== Notificações (push) ===== */
export const listNotifications = (params) => http.get(`${BASE}/notifications`, { params })
export const createNotification = (payload) => http.post(`${BASE}/notifications`, payload)
export const sendNotification = (id) => http.post(`${BASE}/notifications/${id}/send`)
export const deleteNotification = (id) => http.delete(`${BASE}/notifications/${id}`)

/* ===== Palestrantes (Onda 2a) ===== */
export const listSpeakers = (params) => http.get(`${BASE}/speakers`, { params })
export const showSpeaker = (id) => http.get(`${BASE}/speakers/${id}`)
export const createSpeaker = (formData) => http.post(`${BASE}/speakers`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
export const updateSpeaker = (id, formData) => http.post(`${BASE}/speakers/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
export const changeSpeakerStatus = (id) => http.put(`${BASE}/speakers/${id}/status`)
export const reorderSpeakers = (itens) => http.put(`${BASE}/speakers/sequence`, { itens })
export const deleteSpeaker = (id) => http.delete(`${BASE}/speakers/${id}`)

/* ===== Agenda (Onda 2a) ===== */
export const listSchedules = (params) => http.get(`${BASE}/schedules`, { params })
export const showSchedule = (id) => http.get(`${BASE}/schedules/${id}`)
export const createSchedule = (payload) => http.post(`${BASE}/schedules`, payload)
export const updateSchedule = (id, payload) => http.put(`${BASE}/schedules/${id}`, payload)
export const reorderSchedules = (itens) => http.put(`${BASE}/schedules/sequence`, { itens })
export const deleteSchedule = (id) => http.delete(`${BASE}/schedules/${id}`)

/* ===== Vídeos (Onda 2c) ===== */
export const listVideos = () => http.get(`${BASE}/videos`)
export const createVideo = (payload) => http.post(`${BASE}/videos`, payload)
export const updateVideo = (id, payload) => http.put(`${BASE}/videos/${id}`, payload)
export const changeVideoStatus = (id) => http.put(`${BASE}/videos/${id}/status`)
export const reorderVideos = (itens) => http.put(`${BASE}/videos/sequence`, { itens })
export const deleteVideo = (id) => http.delete(`${BASE}/videos/${id}`)

/* ===== Arquivos (Onda 2c) ===== */
export const listArchives = () => http.get(`${BASE}/archives`)
export const createArchive = (formData) => http.post(`${BASE}/archives`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
export const updateArchive = (id, formData) => http.post(`${BASE}/archives/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
export const changeArchiveStatus = (id) => http.put(`${BASE}/archives/${id}/status`)
export const reorderArchives = (itens) => http.put(`${BASE}/archives/sequence`, { itens })
export const deleteArchive = (id) => http.delete(`${BASE}/archives/${id}`)

/* ===== FAQ (Onda 2c) ===== */
export const listFaqs = (params) => http.get(`${BASE}/faq`, { params })
export const createFaq = (payload) => http.post(`${BASE}/faq`, payload)
export const updateFaq = (id, payload) => http.put(`${BASE}/faq/${id}`, payload)
export const deleteFaq = (id) => http.delete(`${BASE}/faq/${id}`)
export const listFaqCategories = () => http.get(`${BASE}/faq/categories`)
export const createFaqCategory = (payload) => http.post(`${BASE}/faq/categories`, payload)
export const updateFaqCategory = (id, payload) => http.put(`${BASE}/faq/categories/${id}`, payload)
export const deleteFaqCategory = (id) => http.delete(`${BASE}/faq/categories/${id}`)

/* ===== Guia (Onda 2d) ===== */
// Hotéis
export const listGuideHotels = () => http.get(`${BASE}/guide/hotels`)
export const createGuideHotel = (payload) => http.post(`${BASE}/guide/hotels`, payload)
export const updateGuideHotel = (id, payload) => http.put(`${BASE}/guide/hotels/${id}`, payload)
export const deleteGuideHotel = (id) => http.delete(`${BASE}/guide/hotels/${id}`)
export const uploadGuideHotelPhoto = (id, file) => {
  const fd = new FormData(); fd.append('photo', file)
  return http.post(`${BASE}/guide/hotels/${id}/photos`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
}
export const deleteGuideHotelPhoto = (id, photoId) => http.delete(`${BASE}/guide/hotels/${id}/photos/${photoId}`)
// Transfers
export const listTransfers = () => http.get(`${BASE}/guide/transfers`)
export const createTransfer = (payload) => http.post(`${BASE}/guide/transfers`, payload)
export const updateTransfer = (id, payload) => http.put(`${BASE}/guide/transfers/${id}`, payload)
export const deleteTransfer = (id) => http.delete(`${BASE}/guide/transfers/${id}`)
// Wi-Fi
export const listWifi = () => http.get(`${BASE}/guide/wifi`)
export const createWifi = (payload) => http.post(`${BASE}/guide/wifi`, payload)
export const updateWifi = (id, payload) => http.put(`${BASE}/guide/wifi/${id}`, payload)
export const deleteWifi = (id) => http.delete(`${BASE}/guide/wifi/${id}`)
// Atividades
export const listActivities = () => http.get(`${BASE}/guide/activities`)
export const createActivity = (payload) => http.post(`${BASE}/guide/activities`, payload)
export const updateActivity = (id, payload) => http.put(`${BASE}/guide/activities/${id}`, payload)
export const changeActivityStatus = (id) => http.put(`${BASE}/guide/activities/${id}/status`)
export const exportActivityParticipants = (id) => http.get(`${BASE}/guide/activities/${id}/export`, { responseType: 'blob' })
export const deleteActivity = (id) => http.delete(`${BASE}/guide/activities/${id}`)

/* ===== Patrocinadores (Onda 2b) ===== */
const multipart = { headers: { 'Content-Type': 'multipart/form-data' } }
// Categorias (tiers)
export const listPartnerCategories = () => http.get(`${BASE}/partners/categories`)
export const createPartnerCategory = (payload) => http.post(`${BASE}/partners/categories`, payload)
export const updatePartnerCategory = (id, payload) => http.put(`${BASE}/partners/categories/${id}`, payload)
export const deletePartnerCategory = (id) => http.delete(`${BASE}/partners/categories/${id}`)
// Patrocinadores
export const listPartners = (params) => http.get(`${BASE}/partners`, { params })
export const showPartner = (id) => http.get(`${BASE}/partners/${id}`)
export const createPartner = (fd) => http.post(`${BASE}/partners`, fd, multipart)
export const updatePartner = (id, fd) => http.post(`${BASE}/partners/${id}`, fd, multipart)
export const changePartnerStatus = (id) => http.put(`${BASE}/partners/${id}/status`)
export const reorderPartners = (itens) => http.put(`${BASE}/partners/sequence`, { itens })
export const deletePartner = (id) => http.delete(`${BASE}/partners/${id}`)
// Vídeos do patrocinador
export const listPartnerVideos = (pid) => http.get(`${BASE}/partners/${pid}/videos`)
export const createPartnerVideo = (pid, payload) => http.post(`${BASE}/partners/${pid}/videos`, payload)
export const updatePartnerVideo = (pid, id, payload) => http.put(`${BASE}/partners/${pid}/videos/${id}`, payload)
export const deletePartnerVideo = (pid, id) => http.delete(`${BASE}/partners/${pid}/videos/${id}`)
// Arquivos do patrocinador
export const exportPartnerContacts = (pid) => http.get(`${BASE}/partners/${pid}/contacts/export`, { responseType: 'blob' })
export const listPartnerArchives = (pid) => http.get(`${BASE}/partners/${pid}/archives`)
export const createPartnerArchive = (pid, fd) => http.post(`${BASE}/partners/${pid}/archives`, fd, multipart)
export const updatePartnerArchive = (pid, id, fd) => http.post(`${BASE}/partners/${pid}/archives/${id}`, fd, multipart)
export const deletePartnerArchive = (pid, id) => http.delete(`${BASE}/partners/${pid}/archives/${id}`)
// Produtos do patrocinador
export const listPartnerProducts = (pid) => http.get(`${BASE}/partners/${pid}/products`)
export const createPartnerProduct = (pid, fd) => http.post(`${BASE}/partners/${pid}/products`, fd, multipart)
export const updatePartnerProduct = (pid, id, fd) => http.post(`${BASE}/partners/${pid}/products/${id}`, fd, multipart)
export const deletePartnerProduct = (pid, id) => http.delete(`${BASE}/partners/${pid}/products/${id}`)
export const listPartnerProductCategories = (pid) => http.get(`${BASE}/partners/${pid}/product-categories`)
export const createPartnerProductCategory = (pid, payload) => http.post(`${BASE}/partners/${pid}/product-categories`, payload)
export const deletePartnerProductCategory = (pid, id) => http.delete(`${BASE}/partners/${pid}/product-categories/${id}`)
// Leads
export const listPartnerContacts = (pid, params) => http.get(`${BASE}/partners/${pid}/contacts`, { params })

/* ===== Moderação do Feed (Onda 3b) ===== */
export const listFeedPosts = (params) => http.get(`${BASE}/feed-posts`, { params })
export const listFeedPostComments = (id) => http.get(`${BASE}/feed-posts/${id}/comments`)
export const deleteFeedPost = (id) => http.delete(`${BASE}/feed-posts/${id}`)
export const deleteFeedComment = (id) => http.delete(`${BASE}/feed-posts/comment/${id}`)

/* ===== Interesses de networking (Onda 3d) ===== */
export const listInterests = () => http.get(`${BASE}/interests`)
export const createInterest = (payload) => http.post(`${BASE}/interests`, payload)
export const updateInterest = (id, payload) => http.put(`${BASE}/interests/${id}`, payload)
export const deleteInterest = (id) => http.delete(`${BASE}/interests/${id}`)

/* ===== Salas ao vivo (Onda 4) ===== */
const mp = { headers: { 'Content-Type': 'multipart/form-data' } }
// Salas
export const listRooms = () => http.get(`${BASE}/rooms`)
export const showRoom = (id) => http.get(`${BASE}/rooms/${id}`)
export const createRoom = (fd) => http.post(`${BASE}/rooms`, fd, mp)
export const updateRoom = (id, fd) => http.post(`${BASE}/rooms/${id}`, fd, mp)
export const changeRoomStatus = (id) => http.put(`${BASE}/rooms/${id}/status`)
export const reorderRooms = (itens) => http.put(`${BASE}/rooms/sequence`, { itens })
export const deleteRoom = (id) => http.delete(`${BASE}/rooms/${id}`)
export const syncRoomSpeakers = (id, speakers) => http.put(`${BASE}/rooms/${id}/speakers`, { speakers })
export const getRoomSettings = (id) => http.get(`${BASE}/rooms/${id}/settings`)
export const updateRoomSettings = (id, payload) => http.put(`${BASE}/rooms/${id}/settings`, payload)
// Transmissões
export const listStreamings = (rid) => http.get(`${BASE}/rooms/${rid}/streamings`)
export const createStreaming = (rid, payload) => http.post(`${BASE}/rooms/${rid}/streamings`, payload)
export const updateStreaming = (rid, id, payload) => http.put(`${BASE}/rooms/${rid}/streamings/${id}`, payload)
export const changeStreamingStatus = (rid, id) => http.put(`${BASE}/rooms/${rid}/streamings/${id}/status`)
export const deleteStreaming = (rid, id) => http.delete(`${BASE}/rooms/${rid}/streamings/${id}`)
// Q&A
export const listRoomAskings = (rid) => http.get(`${BASE}/rooms/${rid}/askings`)
export const replyRoomAsking = (rid, id, payload) => http.put(`${BASE}/rooms/${rid}/askings/${id}/reply`, payload)
export const statusRoomAsking = (rid, id, status) => http.put(`${BASE}/rooms/${rid}/askings/${id}/status`, { status })
export const deleteRoomAsking = (rid, id) => http.delete(`${BASE}/rooms/${rid}/askings/${id}`)
export const listRoomPublicAskings = (rid) => http.get(`${BASE}/rooms/${rid}/public-askings`)
export const replyRoomPublicAsking = (rid, id, payload) => http.put(`${BASE}/rooms/${rid}/public-askings/${id}/reply`, payload)
export const statusRoomPublicAsking = (rid, id, status) => http.put(`${BASE}/rooms/${rid}/public-askings/${id}/status`, { status })
export const deleteRoomPublicAsking = (rid, id) => http.delete(`${BASE}/rooms/${rid}/public-askings/${id}`)
// CTA
export const listCallActions = (rid) => http.get(`${BASE}/rooms/${rid}/call-action`)
export const createCallAction = (rid, payload) => http.post(`${BASE}/rooms/${rid}/call-action`, payload)
export const updateCallAction = (rid, id, payload) => http.put(`${BASE}/rooms/${rid}/call-action/${id}`, payload)
export const deleteCallAction = (rid, id) => http.delete(`${BASE}/rooms/${rid}/call-action/${id}`)
// Enquetes
export const listRoomPolls = (rid) => http.get(`${BASE}/rooms/${rid}/polls`)
// create/update de enquete usam FormData (imagem por opção); update via POST + _method=PUT (spoofing p/ multipart)
export const createRoomPoll = (rid, fd) => http.post(`${BASE}/rooms/${rid}/polls`, fd)
export const updateRoomPoll = (rid, id, fd) => http.post(`${BASE}/rooms/${rid}/polls/${id}`, fd)
export const statusRoomPoll = (rid, id, payload) => http.put(`${BASE}/rooms/${rid}/polls/${id}/status`, payload || {})
export const reorderRoomPolls = (rid, itens) => http.put(`${BASE}/rooms/${rid}/polls/sequence`, { itens })
export const deleteRoomPollOption = (rid, id, optionId) => http.delete(`${BASE}/rooms/${rid}/polls/${id}/options/${optionId}`)
export const chartRoomPoll = (rid, id) => http.get(`${BASE}/rooms/${rid}/polls/${id}/chart`)
export const deleteRoomPoll = (rid, id) => http.delete(`${BASE}/rooms/${rid}/polls/${id}`)
// Quiz
export const listRoomQuiz = (rid) => http.get(`${BASE}/rooms/${rid}/quiz`)
export const createRoomQuiz = (rid, payload) => http.post(`${BASE}/rooms/${rid}/quiz`, payload)
export const updateRoomQuiz = (rid, id, payload) => http.put(`${BASE}/rooms/${rid}/quiz/${id}`, payload)
export const statusRoomQuiz = (rid, id, payload) => http.put(`${BASE}/rooms/${rid}/quiz/${id}/status`, payload || {})
export const reorderRoomQuiz = (rid, itens) => http.put(`${BASE}/rooms/${rid}/quiz/sequence`, { itens })
export const deleteRoomQuizAnswer = (rid, id, answerId) => http.delete(`${BASE}/rooms/${rid}/quiz/${id}/answers/${answerId}`)
export const chartRoomQuiz = (rid, id) => http.get(`${BASE}/rooms/${rid}/quiz/${id}/chart`)
export const deleteRoomQuiz = (rid, id) => http.delete(`${BASE}/rooms/${rid}/quiz/${id}`)
// Nuvem de palavras
export const listRoomWordClouds = (rid) => http.get(`${BASE}/rooms/${rid}/word-clouds`)
export const createRoomWordCloud = (rid, payload) => http.post(`${BASE}/rooms/${rid}/word-clouds`, payload)
export const updateRoomWordCloud = (rid, id, payload) => http.put(`${BASE}/rooms/${rid}/word-clouds/${id}`, payload)
export const statusRoomWordCloud = (rid, id, payload) => http.put(`${BASE}/rooms/${rid}/word-clouds/${id}/status`, payload || {})
export const deleteRoomWordCloud = (rid, id) => http.delete(`${BASE}/rooms/${rid}/word-clouds/${id}`)
export const deleteRoomWord = (rid, id, word) => http.delete(`${BASE}/rooms/${rid}/word-clouds/${id}/word`, { data: { word } })

/* ===== Certificados (Onda 6a) ===== */
export const listCertificatePages = () => http.get(`${BASE}/certificate`)
export const saveCertificatePage = (fd) => http.post(`${BASE}/certificate`, fd, mp)
export const deleteCertificatePage = (id) => http.delete(`${BASE}/certificate/${id}`)
export const listCertificatesIssued = (params) => http.get(`${BASE}/certificate/issued`, { params })

/* ===== Pesquisa de satisfação (Onda 6b) ===== */
export const listSurvey = () => http.get(`${BASE}/survey`)
export const createSurveyQuestion = (payload) => http.post(`${BASE}/survey`, payload)
export const updateSurveyQuestion = (id, payload) => http.put(`${BASE}/survey/${id}`, payload)
export const surveyQuestionStatus = (id) => http.put(`${BASE}/survey/${id}/status`)
export const deleteSurveyQuestion = (id) => http.delete(`${BASE}/survey/${id}`)
export const surveyResults = () => http.get(`${BASE}/survey/results`)
export const reorderSurvey = (itens) => http.put(`${BASE}/survey/sequence`, { itens })
export const deleteSurveyAnswer = (id, answerId) => http.delete(`${BASE}/survey/${id}/answers/${answerId}`)

/* ===== E-mail templates (Onda 6c) ===== */
export const listEmailTemplates = () => http.get(`${BASE}/email`)
export const updateEmailTemplate = (id, payload) => http.put(`${BASE}/email/${id}`, payload)

/* ===== Métricas / relatórios (Onda 6c) ===== */
export const metricsSummary = () => http.get(`${BASE}/metrics/summary`)
export const metricsDashboard = () => http.get(`${BASE}/metrics/dashboard`)
export const exportRanking = () => http.get(`${BASE}/reports/gamification/export`, { responseType: 'blob' })
export const exportSurvey = () => http.get(`${BASE}/reports/survey/export`, { responseType: 'blob' })

/* ===== Gamificação (Onda 5a) ===== */
export const listGamification = () => http.get(`${BASE}/gamification`)
export const createGamRule = (payload) => http.post(`${BASE}/gamification`, payload)
export const updateGamRule = (id, payload) => http.put(`${BASE}/gamification/${id}`, payload)
export const gamRuleStatus = (id) => http.put(`${BASE}/gamification/${id}/status`)
export const deleteGamRule = (id) => http.delete(`${BASE}/gamification/${id}`)
export const toggleGamGlobal = (enabled) => http.put(`${BASE}/gamification/toggle`, { enabled })
export const gamRanking = () => http.get(`${BASE}/gamification/ranking`)
export const exportGamification = () => http.get(`${BASE}/reports/gamification/export`, { responseType: 'blob' })
export const resetGamRanking = () => http.delete(`${BASE}/gamification/reset`)

/* ===== Loja + Carteira (Onda 5b/5c) ===== */
export const adminListStoreProducts = () => http.get(`${BASE}/store/products`)
export const createStoreProduct = (fd) => http.post(`${BASE}/store/products`, fd, mp)
export const updateStoreProduct = (id, fd) => http.post(`${BASE}/store/products/${id}`, fd, mp)
export const storeProductStatus = (id) => http.put(`${BASE}/store/products/${id}/status`)
export const deleteStoreProduct = (id) => http.delete(`${BASE}/store/products/${id}`)
export const reorderStoreProducts = (itens) => http.put(`${BASE}/store/products/sequence`, { itens })
export const adminListStoreCategories = () => http.get(`${BASE}/store/categories`)
export const createStoreCategory = (payload) => http.post(`${BASE}/store/categories`, payload)
export const updateStoreCategory = (id, payload) => http.put(`${BASE}/store/categories/${id}`, payload)
export const deleteStoreCategory = (id) => http.delete(`${BASE}/store/categories/${id}`)
export const adminListStoreOrders = (params) => http.get(`${BASE}/store/orders`, { params })
export const updateStoreOrder = (id, payload) => http.put(`${BASE}/store/orders/${id}`, payload)
export const listWalletBalances = (params) => http.get(`${BASE}/wallet`, { params })
export const adjustWallet = (payload) => http.post(`${BASE}/wallet/adjust`, payload)

/* ===== Sorteios + Recompensas (Onda 5d) ===== */
export const listRaffles = () => http.get(`${BASE}/raffles`)
export const createRaffle = (fd) => http.post(`${BASE}/raffles`, fd, mp)
export const updateRaffle = (id, fd) => http.post(`${BASE}/raffles/${id}`, fd, mp)
export const drawRaffle = (id) => http.post(`${BASE}/raffles/${id}/draw`)
export const deleteRaffle = (id) => http.delete(`${BASE}/raffles/${id}`)
export const listRewards = () => http.get(`${BASE}/rewards`)
export const createReward = (payload) => http.post(`${BASE}/rewards`, payload)
export const updateReward = (id, payload) => http.put(`${BASE}/rewards/${id}`, payload)
export const rewardStatus = (id) => http.put(`${BASE}/rewards/${id}/status`)
export const deleteReward = (id) => http.delete(`${BASE}/rewards/${id}`)
export const listIndications = () => http.get(`${BASE}/indications`)

export default {
  getAppConfig,
  saveAppConfig,
  getAppSettings,
  updateAppInfo,
  updateColors,
  updateAccount,
  updateInteractions,
  getTerms,
  updateTerms,
  uploadImage,
  deleteImage,
  listMenu,
  showMenu,
  createMenu,
  updateMenu,
  changeMenuStatus,
  reorderMenu,
  deleteMenu,
  listFeed,
  createFeed,
  updateFeed,
  changeFeedStatus,
  reorderFeed,
  deleteFeed,
  listNotifications,
  createNotification,
  sendNotification,
  deleteNotification,
  listSpeakers,
  showSpeaker,
  createSpeaker,
  updateSpeaker,
  changeSpeakerStatus,
  reorderSpeakers,
  deleteSpeaker,
  listSchedules,
  showSchedule,
  createSchedule,
  updateSchedule,
  reorderSchedules,
  deleteSchedule,
  listVideos,
  createVideo,
  updateVideo,
  changeVideoStatus,
  reorderVideos,
  deleteVideo,
  listArchives,
  createArchive,
  updateArchive,
  changeArchiveStatus,
  reorderArchives,
  deleteArchive,
  listFaqs,
  createFaq,
  updateFaq,
  deleteFaq,
  listFaqCategories,
  createFaqCategory,
  updateFaqCategory,
  deleteFaqCategory,
  listGuideHotels,
  createGuideHotel,
  updateGuideHotel,
  deleteGuideHotel,
  uploadGuideHotelPhoto,
  deleteGuideHotelPhoto,
  listTransfers,
  createTransfer,
  updateTransfer,
  deleteTransfer,
  listWifi,
  createWifi,
  updateWifi,
  deleteWifi,
  listActivities,
  exportActivityParticipants,
  createActivity,
  updateActivity,
  changeActivityStatus,
  deleteActivity,
  listPartnerCategories,
  createPartnerCategory,
  updatePartnerCategory,
  deletePartnerCategory,
  listPartners,
  showPartner,
  createPartner,
  updatePartner,
  changePartnerStatus,
  reorderPartners,
  deletePartner,
  listPartnerVideos,
  createPartnerVideo,
  updatePartnerVideo,
  deletePartnerVideo,
  listPartnerArchives,
  createPartnerArchive,
  updatePartnerArchive,
  deletePartnerArchive,
  listPartnerProducts,
  createPartnerProduct,
  updatePartnerProduct,
  deletePartnerProduct,
  listPartnerProductCategories,
  createPartnerProductCategory,
  deletePartnerProductCategory,
  listPartnerContacts,
  exportPartnerContacts,
  listFeedPosts,
  listFeedPostComments,
  deleteFeedPost,
  deleteFeedComment,
  listInterests,
  createInterest,
  updateInterest,
  deleteInterest,
  listRooms,
  showRoom,
  createRoom,
  updateRoom,
  changeRoomStatus,
  reorderRooms,
  deleteRoom,
  syncRoomSpeakers,
  getRoomSettings,
  updateRoomSettings,
  listStreamings,
  createStreaming,
  updateStreaming,
  changeStreamingStatus,
  deleteStreaming,
  listRoomAskings,
  replyRoomAsking,
  statusRoomAsking,
  deleteRoomAsking,
  listRoomPublicAskings,
  replyRoomPublicAsking,
  statusRoomPublicAsking,
  deleteRoomPublicAsking,
  listCallActions,
  createCallAction,
  updateCallAction,
  deleteCallAction,
  listRoomPolls,
  createRoomPoll,
  updateRoomPoll,
  statusRoomPoll,
  reorderRoomPolls,
  deleteRoomPollOption,
  chartRoomPoll,
  deleteRoomPoll,
  listRoomQuiz,
  createRoomQuiz,
  updateRoomQuiz,
  statusRoomQuiz,
  reorderRoomQuiz,
  deleteRoomQuizAnswer,
  chartRoomQuiz,
  deleteRoomQuiz,
  listRoomWordClouds,
  createRoomWordCloud,
  updateRoomWordCloud,
  statusRoomWordCloud,
  deleteRoomWordCloud,
  deleteRoomWord,
  // gamificação
  listGamification,
  createGamRule,
  updateGamRule,
  gamRuleStatus,
  deleteGamRule,
  toggleGamGlobal,
  gamRanking,
  exportGamification,
  resetGamRanking,
  // loja/carteira
  adminListStoreProducts,
  createStoreProduct,
  updateStoreProduct,
  storeProductStatus,
  deleteStoreProduct,
  reorderStoreProducts,
  adminListStoreCategories,
  createStoreCategory,
  updateStoreCategory,
  deleteStoreCategory,
  adminListStoreOrders,
  updateStoreOrder,
  listWalletBalances,
  adjustWallet,
  // sorteios/rewards
  listRaffles,
  createRaffle,
  updateRaffle,
  drawRaffle,
  deleteRaffle,
  listRewards,
  createReward,
  updateReward,
  rewardStatus,
  deleteReward,
  listIndications,
  // certificados / pesquisa / e-mail / métricas
  listCertificatePages,
  saveCertificatePage,
  deleteCertificatePage,
  listCertificatesIssued,
  listSurvey,
  createSurveyQuestion,
  updateSurveyQuestion,
  reorderSurvey,
  deleteSurveyAnswer,
  surveyQuestionStatus,
  deleteSurveyQuestion,
  surveyResults,
  listEmailTemplates,
  updateEmailTemplate,
  metricsSummary,
  metricsDashboard,
  exportRanking,
  exportSurvey
}
